"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ui_lib_v2_1 = require("@whispir/ui-lib-v2");
var TrackEventProvider_1 = require("../Providers/TrackEventProvider");
var loadingStartTime;
var fullFlowStartTime;
var UploadImage = function (_a) {
    var onSelectedImage = _a.onSelectedImage, _b = _a.label, label = _b === void 0 ? 'Image' : _b, currentSource = _a.currentSource, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.errors, errors = _d === void 0 ? [] : _d, uploadedSource = _a.uploadedSource, handleUploadImage = _a.handleUploadImage, onModalClose = _a.onModalClose;
    var events = (0, TrackEventProvider_1.useTrackingEvents)();
    var _e = (0, react_1.useState)(undefined), modalStep = _e[0], setModalStep = _e[1];
    var trackingData = {
        errors: errors,
        uploadedImageUrl: uploadedSource || '',
        currentSrcUrl: currentSource || '',
    };
    (0, react_1.useEffect)(function () {
        if (errors.length > 0)
            setModalStep('upload');
    }, [errors]);
    (0, react_1.useEffect)(function () {
        if (loading) {
            loadingStartTime = new Date();
        }
        else if (loadingStartTime) {
            events.trackImageUploaded(__assign({ uploadTimeSeconds: (new Date().getTime() - loadingStartTime.getTime()) / 1000 }, trackingData));
        }
    }, [loading]);
    var handleSetModalStep = function (step) {
        // Segment tracking
        switch (step) {
            case 'source':
                events.trackClickedFromUrl(trackingData);
                break;
            case 'upload':
                events.trackClickedFromDevice(trackingData);
                break;
            case 'rename':
                break;
            case undefined:
                break;
        }
        setModalStep(step);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [currentSource ? ((0, jsx_runtime_1.jsx)(ui_lib_v2_1.UploadedImage, { title: label, src: currentSource, onDelete: function () {
                    events.trackClickedDeleteImage(trackingData);
                    onSelectedImage('');
                }, onClose: function () { return events.trackDeleteModalCancelButtonClicked(trackingData); }, onDeleteIconClicked: function () { return events.trackClickedDeleteIconLaunchModal(trackingData); } }, void 0)) : ((0, jsx_runtime_1.jsx)(ui_lib_v2_1.PopoverMenuSimpleButton, { size: "medium", text: "Upload image", menuItems: [
                    {
                        label: 'From device',
                        onClick: function () { return handleSetModalStep('upload'); },
                    },
                    {
                        label: 'From URL',
                        onClick: function () { return handleSetModalStep('source'); },
                    },
                ], endIcon: "Accordian", type: "secondary", anchorOrigin: {
                    horizontal: 'left',
                    vertical: 'bottom',
                }, onOpen: function () {
                    events.trackUploadImageClicked(trackingData);
                    fullFlowStartTime = new Date();
                } }, void 0)), modalStep && ((0, jsx_runtime_1.jsx)(ui_lib_v2_1.FileUploadModal, { uploadPrompt: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Drag an image to upload or ", (0, jsx_runtime_1.jsx)("span", __assign({ style: { color: ui_lib_v2_1.Colors.accent } }, { children: "browse" }), void 0)] }, void 0), step: loading ? 'loading' : modalStep, fileCategory: "image", fileTypes: ".jpg, .jpeg, .png", sizeLimitMB: 6, onInsertButtonClicked: function (url) {
                    if (uploadedSource) {
                        onSelectedImage(uploadedSource);
                    }
                    if (modalStep === 'source' && url && url.length > 0) {
                        onSelectedImage(url);
                    }
                    events.trackInsertClicked(__assign({ uploadType: uploadedSource ? 'device' : 'url', fromUrl: url, fullFlowTime: fullFlowStartTime
                            ? "" + (new Date().getTime() - fullFlowStartTime.getTime()) / 1000
                            : '' }, trackingData));
                    handleSetModalStep(undefined);
                }, handleExit: function () {
                    events.trackModalClosed(trackingData);
                    handleSetModalStep(undefined);
                    if (onModalClose) {
                        onModalClose();
                    }
                }, onFileSelected: function (fileData) {
                    var data = fileData;
                    var base64 = data === null || data === void 0 ? void 0 : data.base64;
                    var file = data === null || data === void 0 ? void 0 : data.file;
                    var selectionType = ((data === null || data === void 0 ? void 0 : data.fileSelectionType) || '');
                    if (base64 && file) {
                        events.trackImageSelected(__assign({ 
                            // might have to take this out due to size limits
                            imageBase64: base64, fileName: file === null || file === void 0 ? void 0 : file.name, fileSize: file === null || file === void 0 ? void 0 : file.size, fileType: file === null || file === void 0 ? void 0 : file.type, fileLastModified: file === null || file === void 0 ? void 0 : file.lastModified, selectionType: selectionType }, trackingData));
                        handleUploadImage({ file: file });
                    }
                    handleSetModalStep('rename');
                }, isOpen: true, imageUrl: uploadedSource, errorMessages: errors }, void 0))] }, void 0));
};
exports.UploadImage = UploadImage;
exports.default = exports.UploadImage;
